import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import JPSTimelineBox from './JPSTimelineBox';
import { PreviewButton } from '../../../components/button/ActionButton';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';
import { getUserLanguage } from '../../../utils/LanguageUtil';

class JPSRespondentDetailComponent extends Component {
  render() {
    const {
      sendInviteEmail,
      sendRemindingEmail,
      previewJPSSurvey,
      availableTranslations,
      emailSending,
      isPreview,
      jobProfileSurvey,
    } = this.props;
    const {
      expiredOn, createdOn, locale, respondent, jobProfile,
    } = jobProfileSurvey;
    const template = jobProfile && jobProfile.template ? jobProfile.template : {};

    const translatedLocale = getUserLanguage(locale, availableTranslations);
    return (
      <div>
        <div className="wrapper">
          <h1 className="border-bottom no-margin clearfix">
            <div className="p-grid">
              <div className="p-col p-md-7 p-sm-12">
                {respondent.firstName}
                {' '}
                {respondent.lastName}
              </div>
              <div className="p-col p-md-5 p-sm-12">
                {// isAuthorizedUser(AuthorizedUser.TESTER)
                  false && (
                    <PreviewButton position="left" onClick={previewJPSSurvey} textId="preview" isPreview={isPreview} />
                  )}
              </div>
            </div>
          </h1>
          <div className="p-grid">
            <div className="p-col p-md-7 p-sm-12">
              <div>
                <h2 className="text-muted">
                  <FormattedMessage id="assessment" defaultMessage="Assessment" />
                  :
                  <strong>{template.title}</strong>
                </h2>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="attrs.language" defaultMessage="Language" />
                    :
                  </div>
                  <div>{translatedLocale && <span>{translatedLocale.name}</span>}</div>
                </div>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="attrs.created" defaultMessage="Created" />
                    :
                  </div>
                  <div>
                    <span>
                      <Gr8piFormattedDate dateValue={createdOn} />
                    </span>
                  </div>
                </div>
                <div className="survey-details">
                  <div>
                    <FormattedMessage id="assessment.expiresOn" defaultMessage="Expires on" />
                    :
                  </div>
                  <div>
                    <span>{expiredOn && <Gr8piFormattedDate dateValue={expiredOn} />}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-col p-md-5 p-sm-12">
              <Panel>
                <JPSTimelineBox
                  sendInviteEmail={sendInviteEmail}
                  sendRemindingEmail={sendRemindingEmail}
                  JPSData={jobProfileSurvey}
                  isEmailSending={emailSending}
                />
              </Panel>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

JPSRespondentDetailComponent.propTypes = {
  sendInviteEmail: PropTypes.func.isRequired,
  sendRemindingEmail: PropTypes.func.isRequired,
  previewJPSSurvey: PropTypes.func.isRequired,
  emailSending: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  jobProfileSurvey: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default JPSRespondentDetailComponent;
